// Grid tiers that give up AG Grid cell selection turn on `enableCellTextSelection` (see
// AgGridSsrmComponentController#buildCellTextSelection) so an admin can drag-highlight cell
// text. The browser still fires a click where the drag ended, which for a POST link cell would
// silently turn "selected the email" into "impersonated that user" — link handlers ask this
// first and bail out.
export function completesTextSelection(element: HTMLElement): boolean {
  const selection = window.getSelection();
  if (!selection || selection.isCollapsed || selection.toString().trim() === "") return false;

  // containsNode's `partialContainment` covers a selection that runs across the whole
  // link; the anchor/focus checks cover one that starts or ends inside it.
  return (
    selection.containsNode(element, true) ||
    (selection.anchorNode !== null && element.contains(selection.anchorNode)) ||
    (selection.focusNode !== null && element.contains(selection.focusNode))
  );
}
